var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.241 6.515a.864.864 0 0 1 .031-1.228 1.06 1.06 0 0 1 1.332-.097l.076.062 9.699 9.417.144.142c.68.732.633 1.843-.144 2.52L11.68 26.75l-.077.06a1.06 1.06 0 0 1-1.33-.094.867.867 0 0 1 .038-1.296l9.697-9.42-9.697-9.417z"
  })));
};
export default SvgChevronRight;